import React from "react";

const FilmGrain = () => {
  return (
    <div 
      className="film-grain" 
      data-testid="film-grain-overlay"
      aria-hidden="true"
    />
  );
};

export default FilmGrain;
